import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { loadConfig } from './config';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Block render until runtime /config.json is loaded so AuthProvider can
// read final Cognito values synchronously. The fetch is short-circuited
// to a stub in VITE_LOCAL_DEV mode (see config.ts).
loadConfig()
  .then(() => {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  })
  .catch((err) => {
    // Render a minimal error surface so the user sees SOMETHING. Without
    // this the page silently blanks out if /config.json 404s.
    root.innerHTML =
      '<pre style="padding:2rem;font-family:system-ui;color:#b91c1c">Admin config failed to load: ' +
      String(err) +
      '</pre>';
  });
